/** @jsx jsx */
import { Button } from '@datacamp/waffles/button';
import { Checkmark, Cross } from '@datacamp/waffles/icon';
import { Paragraph } from '@datacamp/waffles/paragraph';
import { tokens } from '@datacamp/waffles/tokens';
import { jsx } from '@emotion/react';

import { isFeatureEnabled } from '../../helpers/featureFlags';

type Props = {
  onRateClick: () => void;
};

const LearningRecapRating: React.FC<Props> = ({ onRateClick }) => {
  const newLearningRecapsEnabled = isFeatureEnabled('cp--campus-api-db-recaps');
  return (
    <div
      style={{
        alignItems: 'center',
        display: 'flex',
        flexGrow: 1,
        gap: tokens.spacing.small,
      }}
    >
      <Paragraph
        style={{
          margin: 0,
          fontSize: tokens.fontSizes.medium,
          fontWeight: tokens.fontWeights.bold,
        }}
      >
        Was this useful?
      </Paragraph>
      <div>
        <Button
          data-cy="learn-recap-positive-rate-button"
          data-trackid={
            newLearningRecapsEnabled
              ? 'learning-recap-positive-rating'
              : 'learning-recap-positive-rating-old'
          }
          aria-label="Yes"
          css={{
            border: 'none',
            fontSize: tokens.fontSizes.medium,
            fontWeight: tokens.fontWeights.regular,
          }}
          onClick={onRateClick}
          size="small"
        >
          <Checkmark />
          Yes
        </Button>
        <Button
          data-cy="learn-recap-negative-rate-button"
          aria-label="No"
          data-trackid={
            newLearningRecapsEnabled
              ? 'learning-recap-negative-rating'
              : 'learning-recap-negative-rating-old'
          }
          css={{
            border: 'none',
            fontSize: tokens.fontSizes.medium,
            fontWeight: tokens.fontWeights.regular,
          }}
          onClick={onRateClick}
          size="small"
        >
          <Cross color={tokens.colors.red} />
          No
        </Button>
      </div>
    </div>
  );
};

export default LearningRecapRating;
